import type { LazyModuleConfigured } from './configure-lazy-module';

/**
 * List of all modules that should lazily be loaded.
 */
export const allLazyModules: LazyModuleConfigured[] = [];
